import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import '../../entity-forms.css';

export default function Devices() {
  const API_URL = process.env.REACT_APP_API_URL;

  const [data, setdata]             = useState([]);
  const [isload, setisload]         = useState(true);
  const [drivers, setdrivers]       = useState([]);
  const [search, setSearch]         = useState('');

  const initForm = { createdBy: sessionStorage.getItem('userid'), status: 'active' };
  const [form, setForm]             = useState(initForm);
  const [isEdit, setIsEdit]         = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [msg, setMsg]               = useState('');
  const [errMsg, setErrMsg]         = useState('');

  useEffect(() => { loadList(); loadDrivers(); }, []);

  const loadList = async () => {
    setisload(true);
    try {
      const res = await axios.get(`${API_URL}shypvdriverapp/team/getDevices`);
      if (res.data?.data) setdata(res.data.data);
    } catch {}
    setisload(false);
  };

  const loadDrivers = async () => {
    try {
      const res = await axios.get(`${API_URL}shypvdriverapp/driver/getAllDrivers`);
      if (res.data?.data) setdrivers(res.data.data);
    } catch {}
  };

  const openAdd  = () => { setForm(initForm); setIsEdit(false); setMsg(''); setErrMsg(''); setDrawerOpen(true); };
  const openEdit = (row) => { setForm({ ...row }); setIsEdit(true); setMsg(''); setErrMsg(''); setDrawerOpen(true); };
  const closeDrawer = () => { setDrawerOpen(false); setForm(initForm); };

  const handleSubmit = async () => {
    if (!form.modelName || !form.imeiNumber || !form.version || !form.assignedTo) {
      setMsg('Please fill all required fields (*)'); return;
    }
    setMsg('');
    try {
      const payload = {
        modelName: form.modelName,
        imeiNumber: form.imeiNumber,
        version: form.version,
        assignedTo: form.assignedTo,
        createdBy: form.createdBy,
        status: form.status || 'active',
      };
      if (isEdit) payload.deviceId = form.deviceId;
      const url = isEdit
        ? `${API_URL}shypvdriverapp/team/updateDevice`
        : `${API_URL}shypvdriverapp/team/createDevice`;
      const res = await axios.post(url, payload, { headers: { 'Content-Type': 'application/json' } });
      if (res.data.success) { closeDrawer(); loadList(); }
      else setMsg('Operation failed. Please try again.');
    } catch (e) { setErrMsg('Server error: ' + (e.response?.data?.message || e.message)); }
  };

  const handleDelete = async () => {
    if (!selectedIds.length) return;
    if (!window.confirm(`Delete ${selectedIds.length} device(s)?`)) return;
    try {
      for (const id of selectedIds) {
        await axios.delete(`${API_URL}shypvdriverapp/team/deleteDevice`, {
          headers: { 'Content-Type': 'application/json' },
          data: { deviceId: id },
        });
      }
      setSelectedIds([]); loadList();
    } catch { setErrMsg('Error deleting device'); }
  };

  const toggleSelect = (id, row) => {
    setSelectedIds(prev => {
      if (prev.includes(id)) { const next = prev.filter(x => x !== id); if (!next.length) setForm(initForm); return next; }
      setForm(row); return [...prev, id];
    });
  };

  const filtered = data.filter(r =>
    !search ||
    r.modelName?.toLowerCase().includes(search.toLowerCase()) ||
    r.imeiNumber?.toLowerCase().includes(search.toLowerCase())
  );

  const role = sessionStorage.getItem('role');
  const canDelete = role === 'super_admin' || role === 'admin';

  return (
    <div style={{ fontFamily:"'Poppins', sans-serif" }}>
      <div className="em-action-bar">
        <div className="em-search-wrap">
          <i className="fa fa-search" />
          <input className="em-search" placeholder="Search devices…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <button className="em-btn em-btn-primary" onClick={openAdd}><i className="fa fa-plus" /> Add Device</button>
        {selectedIds.length === 1 && (
          <button className="em-btn em-btn-warning" onClick={() => openEdit(form)}><i className="fa fa-pencil" /> Edit</button>
        )}
        {selectedIds.length > 0 && canDelete && (
          <button className="em-btn em-btn-danger" onClick={handleDelete}><i className="fa fa-trash" /> Delete ({selectedIds.length})</button>
        )}
        <CSVLink data={filtered} filename="devices.csv" className="em-btn em-btn-csv"><i className="fa fa-download" /> Export</CSVLink>
        {errMsg && <span className="em-msg-error">{errMsg}</span>}
      </div>

      <div style={{ overflowX:'auto' }}>
        <table className="em-table">
          <thead>
            <tr>
              <th className="em-col-h" style={{ width:36 }}>
                <input type="checkbox" onChange={e => setSelectedIds(e.target.checked ? filtered.map(r => r.deviceId) : [])}
                  checked={selectedIds.length > 0 && selectedIds.length === filtered.length} />
              </th>
              {['ID','Model','IMEI','Version','Assigned To','Status','Actions'].map(h => <th key={h} className="em-col-h">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {isload ? (
              <tr><td colSpan={8} style={{ textAlign:'center', padding:40, color:'#94a3b8' }}>
                <i className="fa fa-spinner fa-spin" style={{ fontSize:22, display:'block', marginBottom:8 }} />Loading devices…
              </td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={8} style={{ textAlign:'center', padding:40, color:'#94a3b8' }}>No devices found</td></tr>
            ) : filtered.map((row, i) => {
              const sel = selectedIds.includes(row.deviceId);
              return (
                <tr key={row.deviceId} className={`em-tr${sel?' selected':''}`}
                  style={{ animation:`emFadeUp 0.3s ${Math.min(i,20)*0.018}s ease-out both` }}>
                  <td className="em-td"><input type="checkbox" checked={sel} onChange={() => toggleSelect(row.deviceId, row)} /></td>
                  <td className="em-td" style={{ color:'#64748b', fontSize:12 }}>{row.deviceId}</td>
                  <td className="em-td" style={{ fontWeight:600 }}>{row.modelName}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.imeiNumber}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.version}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.assignedTo}</td>
                  <td className="em-td">
                    <span className={`em-badge ${row.status==='active'?'em-badge-green':'em-badge-grey'}`}>{row.status}</span>
                  </td>
                  <td className="em-td">
                    <button className="em-btn em-btn-ghost" style={{ padding:'5px 10px', fontSize:11 }} onClick={() => openEdit(row)}>
                      <i className="fa fa-pencil" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div style={{ padding:'10px 16px', background:'#f8fafc', borderTop:'1px solid #e8edf2', fontSize:12, color:'#94a3b8', fontWeight:600 }}>
        {filtered.length} device{filtered.length!==1?'s':''}
      </div>

      {drawerOpen && (
        <>
          <div className="em-overlay" onClick={closeDrawer} />
          <div className="em-drawer">
            <div className="em-drawer-header">
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{ width:36, height:36, borderRadius:11, background:'rgba(255,255,255,0.12)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <i className="fa fa-mobile" style={{ color:'#fff', fontSize:16 }} />
                  </div>
                  <div>
                    <p className="em-drawer-title">{isEdit ? 'Edit Device' : 'Add New Device'}</p>
                    <p className="em-drawer-sub">{isEdit ? `ID: ${form.deviceId}` : 'Fill in the device details below'}</p>
                  </div>
                </div>
                <button onClick={closeDrawer} style={{ background:'rgba(255,255,255,0.1)', border:'none', borderRadius:10, width:30, height:30, cursor:'pointer', color:'#fff', fontSize:18, display:'flex', alignItems:'center', justifyContent:'center' }}>×</button>
              </div>
            </div>
            <div className="em-drawer-body">
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Model Name<span className="em-req">*</span></label>
                  <input className="em-field" value={form.modelName||''} placeholder="e.g. Samsung A52"
                    onChange={e => setForm(p => ({ ...p, modelName: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">IMEI Number<span className="em-req">*</span></label>
                  <input className="em-field" value={form.imeiNumber||''} placeholder="15-digit IMEI"
                    onChange={e => setForm(p => ({ ...p, imeiNumber: e.target.value }))} />
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">OS Version<span className="em-req">*</span></label>
                  <input className="em-field" value={form.version||''} placeholder="e.g. Android 13"
                    onChange={e => setForm(p => ({ ...p, version: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">Assigned To (Driver)<span className="em-req">*</span></label>
                  <select className="em-field" value={form.assignedTo||''} onChange={e => setForm(p => ({ ...p, assignedTo: e.target.value }))}>
                    <option value="">— Select driver —</option>
                    {drivers.map(d => <option key={d.driverId} value={d.driverId}>{d.name || d.driverId}</option>)}
                    {!drivers.length && <option disabled>Loading drivers…</option>}
                  </select>
                </div>
              </div>
              <div className="em-form-row" style={{ maxWidth:220 }}>
                <label className="em-label">Status</label>
                <select className="em-field" value={form.status||'active'} onChange={e => setForm(p => ({ ...p, status: e.target.value }))}>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
              {msg    && <p className="em-msg-error">{msg}</p>}
              {errMsg && <p className="em-msg-error">{errMsg}</p>}
            </div>
            <div className="em-drawer-footer">
              <button className="em-dismiss-btn" onClick={closeDrawer}>Cancel</button>
              <button className="em-save-btn" onClick={handleSubmit}>
                <i className="fa fa-check" style={{ marginRight:6 }} />{isEdit?'Update Device':'Save Device'}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
